import { ArrowUpDown } from "lucide-react"
import { SortDisplayT, getSortOrderIcon } from "shared-ts/hooks/useSort/helpers"

import { ButtonProps } from "../../../../../components/base/control/Button"
import { DropdownButton } from "../../DropdownButton/DropdownButton"

interface SortButtonProps extends Omit<ButtonProps, "mode" | "tone"> {
  sort: SortDisplayT | null
}

export const SortButton = ({
  sort: sort,
  onClick,
  disabled,
  ref,
}: SortButtonProps) => {
  const icon = !sort ? ArrowUpDown : getSortOrderIcon(sort.order)
  const hideDropdownIcon = !sort
  const selected = !!sort
  const label = sort ? sort.label : "Sort"

  return (
    <DropdownButton
      ref={ref}
      icon={icon}
      label={label}
      mode="secondary"
      selected={selected}
      hideDropdownIcon={hideDropdownIcon}
      onClick={onClick}
      disabled={disabled}
    />
  )
}
